import React from 'react';

import Input from '../Input';
import normalize from './normalize';
import format from './format';
import validate from './validate';
import withSelectAll from '../withSelectAll';
import { useTranslation } from 'react-i18next';

function SocialSecurityNumberInput({ ...props }) {
  const { t } = useTranslation();
  return (
    <Input
      placeholder={t("ÅÅÅÅMMDD-XXXX")}
      maxLength={13}
      inputmode="numeric"
      pattern="[0-9]*"
      {...props}
    />
  );
}

SocialSecurityNumberInput.format = v => v;
SocialSecurityNumberInput.normalize = v => v;
SocialSecurityNumberInput.validate = validate;


export default SocialSecurityNumberInput;
// withSelectAll(SocialSecurityNumberInput);
